
import Slider from "react-slick";
import { IHomeSlide } from "../../types/home_slider";

function AnnouncementSliderComponent({ ...props }) {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        dir: 'auto',
        rtl: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    if (props.settings) {
        settings = props.settings;
    }

    console.log(props.slides);

    return (

        <Slider className="slider-body     slider-body-announcement"  {...settings}>


            {props.slides.map((slideRow: IHomeSlide) => (

                <div className="slider-item">
                    <a target={"_blank"} href={slideRow.Url} className="d-block">
                        <img src={`${process.env.REACT_APP_CMS}${slideRow.Image?.url}`} width="400px"  alt="img" className="img-fluid" />
                    </a>
                </div>
            ))}




        </Slider>




    );
}

export default AnnouncementSliderComponent;


